export const STATUS = {
  ERROR: "error",
  FAILED: "failed",
  ACTIVE: "active",
  PENDING: "pending",
  SUCCESS: "success",
  ENABLED: "enabled",
  DISABLED: "disabled",
  COMPLETED: "completed",
  INITIALIZED: "initialized",
} as const
